<template>
  <div>
    <v-select
        class="small-text-field "
        :required="required"
        :value="paymentType"
        :items="availablePaymentTypes"
        :v-model="paymentType"
        item-value="type"
        item-name="name"
        @input="updateSelf"
        :height="28"
        :hide-details="valid() == true && (error == null || error.length == 0)"
        :error-messages="valid() == true ? null : [valid()] "
        outlined
        dense
        :label="label"
    >
      <template v-slot:selection="{ item, index }">
      <span
          style="font-size: 12px !important;"
      >{{item.name}}&nbsp;{{ (item.type == "account" && user.business) || item.type != "account" ? "" : "⚠️" }}</span>
      </template>
      <template v-slot:item="{ item, index }">
      <span
          style="font-size: 12px !important;"
      >{{item.name}}&nbsp;{{ (item.type == "account" && user.business) || item.type != "account" ? "" : "(User is not a business customer)" }}</span>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: "SelectablePaymentTypeInput",
  model: {
    prop: "paymentType",
    event: "input"
  },
  props: {
    label: String,
    errorMessages: Object,
    required: { type: Boolean, default: true },
    paymentType: String,
    paymentTypes: Array,
    user: Object,
    error: String
  },
  computed: {
    availablePaymentTypes: function() {
      return this.paymentTypes;
    }
  },
  data() {
    return {
      menu: false
    };
  },
  mounted: function() {},
  methods: {
    valid() {
      if (this.error == null) {
        return true;
      }

      return this.error;
    },
    updateSelf(rideType) {
      this.$emit("input", rideType);
    },
    focused() {
      console.log("focused");
      this.$emit("focused");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
